import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

class PAUTSummaryForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		weldNumber: Joi.string().min(3).required().label('Weld Number'),
		phasedArray: Joi.string().min(3).required().label('Phased Array (PAUT)'),
		viResult: Joi.string().min(3).required().label('Visual Inspection Result'),
		mpiResult: Joi.string().min(3).required().label('MPI Result'),
		shearWaveResult: Joi.string().min(3).required().label('Shear Wave Result'),
		defectType: Joi.string().min(3).required().label('Defect Type'),
		result: Joi.string().required().label('Result'),
		remark: Joi.string().min(3).required().label('Remark'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'weldNumber',
							label: 'Weld Number',
							placeholder: 'Enter Weld Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'phasedArray',
							label: 'Phased Array (PAUT)',
							placeholder: 'Enter Phased Array (PAUT)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'viResult',
							label: 'Visual Inspection Result',
							placeholder: 'Enter Visual Inspection Result',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'mpiResult',
							label: 'MPI Result',
							placeholder: 'MPI Result',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'shearWaveResult',
							label: 'Shear Wave Result',
							placeholder: 'Enter Shear Wave Result',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'defectType',
							label: 'Defect Type',
							placeholder: 'Enter Defect Type',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result',
							placeholder: 'Select Result',
							options: data.getResultOptions(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderTextArea({
							name: 'remark',
							label: 'Remark',
							placeholder: 'Enter Remark',
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData: models.PAUTSummaryData = {
	weldNumber: '',
	phasedArray: '',
	viResult: '',
	mpiResult: '',
	shearWaveResult: '',
	defectType: '',
	result: '',
	remark: '',
};

export default PAUTSummaryForm;
